interface NotationButtonLabelProps {
  prefix: string;
}

const NotationButtonLabel = ({ prefix }: NotationButtonLabelProps) => (
  <span className="inline-flex items-center gap-[0.35em]">
    <span className="leading-none">{prefix}</span>
    <span
      className="text-[1.08em] leading-none translate-y-[0.12em]"
      style={{ fontFamily: "'Baloo Bhaina 2', sans-serif" }}
    >
      notation
    </span>
  </span>
);

export default NotationButtonLabel;
